import { render, staticRenderFns } from "./TerritoryDocBoundary.vue?vue&type=template&id=ca5808fe&"
import script from "./TerritoryDocBoundary.vue?vue&type=script&lang=js&"
export * from "./TerritoryDocBoundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports